@if (note.isDeleted) {
    <div
        class="d-flex flex-row align-items-start note-item panel-list-item mw-100 note-deleted"
        [ngClass]="{ highlighted: note.id === noteService.noteIdWithMentionedUser }">
        <i class="fas fa-trash-alt deleted-avatar"></i>

        <div class="position-relative editor-block w-100">
            <div class="text-break-all text-light">
                {{ 'This message was deleted.' | translate }}
            </div>
        </div>
    </div>
} @else {
    <div
        class="d-flex flex-row align-items-start note-item panel-list-item mw-100"
        [ngClass]="{ highlighted: note.id === noteService.noteIdWithMentionedUser }">
        <sb-user-avatar
            [ngClass]="{ 'user-avatar-xs': isSubNote, 'user-avatar-sm': !isSubNote }"
            class="pointer"
            (click)="rightPanelService.open(rightPanelTypeEnum.user, { user: note.author })"
            [user]="note.author"
            [size]="isSubNote ? 'extra-small' : 'small'"
            [isNeedTooltip]="false"
            [withRoleTooltip]="true"></sb-user-avatar>
        <div class="position-relative editor-block w-100">
            <div class="text-break-all">
                {{ note.author.name || note.author.email }}
                <small
                    class="time text-light"
                    style="white-space: nowrap"
                    tooltip="{{ note.creationTime | date: 'dd.MM.yyyy HH:mm' }}"
                    container="body">
                    {{ note.creationTime | timeAgo }}
                </small>
            </div>
            <div class="note-content text-break">
                @if (note.reply) {
                    <app-reply-quote [reply]="note.reply"></app-reply-quote>
                }
                <app-highlight-mention
                    [hidden]="note.isEditing"
                    [message]="note.message.html || note.message.text"
                    [isHtml]="!!note.message.html"
                    [mentionedUsers]="note.mentionedUsers">
                </app-highlight-mention>

                @if (note.attachments.length) {
                    <div class="mt-2" [hidden]="note.isEditing">
                        @for (attachment of note.attachments; track attachment; let idx = $index) {
                            <sb-file-preview
                                class="file-container"
                                [attachments]="note.attachments"
                                [attachment]="attachment"
                                [fileIndex]="idx"
                                [permalink]="ticketDetailsPanelService.currentTicket.permalink">
                            </sb-file-preview>
                        }
                        <div class="clearfix"></div>
                    </div>
                }
            </div>

            @if (!note.isEditing && !commonDataService.user.isReadOnly) {
                <small class="print-hidden">
                    <a (click)="toggleSubNoteEditor(true)">{{ 'Reply' | translate }}</a>
                </small>
            }

            @if (note.isEditing) {
                <div class="mt-2">
                    <app-note-quill-editor
                        [note]="editableNote"
                        [attachments]="attachments"
                        [quillRange]="quillRange"
                        [noteId]="note.id"
                        [toolbarSize]="isSubNote ? 'xsmall' : 'small'"
                        (isInvalidChanged)="isInvalidMessage = $event"
                        (editorCreated)="quillEditor = $event"
                        (updateQuillSelection)="updateQuillSelection()"
                        (addNote)="doneEditNote()">
                    </app-note-quill-editor>

                    @if (attachments.length) {
                        <div class="attachments-block mt-2">
                            @for (attachment of attachments; track attachment; let idx = $index; let odd = $odd) {
                                <sb-file-preview
                                    [attachments]="attachments"
                                    [ngClass]="{ 'me-0': odd, 'file-preview--small-version': !parentNote }"
                                    [attachment]="attachment"
                                    [fileIndex]="idx"
                                    [canBeRemoved]="true"
                                    [permalink]="ticketDetailsPanelService.currentTicket.permalink"></sb-file-preview>
                            }
                            <div class="clearfix"></div>
                        </div>
                    }

                    <div class="mt-2 print-hidden">
                        <div class="clearfix"></div>
                        <div class="buttons-panel text-end">
                            <button
                                class="btn btn-icon ms-0"
                                (click)="parent.openReplyTemplatesModal($event, quillEditor, attachments)"
                                tooltip="{{ 'Insert a saved template' | translate }}"
                                [disabled]="isSaving"
                                container="body">
                                <sb-inline-svg
                                    class="icon"
                                    [url]="
                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'
                                    "></sb-inline-svg>
                            </button>
                            <button
                                class="btn btn-icon"
                                tooltip="{{ 'Attachments' | translate }}"
                                container="body"
                                (click)="openAttachmentsModal()"
                                [disabled]="isSaving">
                                <sb-inline-svg
                                    class="icon"
                                    [url]="
                                        '/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'
                                    "></sb-inline-svg>
                            </button>
                            <button class="btn" (click)="cancelEditNote()" [disabled]="isSaving">
                                {{ 'cancel' | translate }}
                            </button>
                            <button
                                class="btn"
                                [disabled]="(isInvalidMessage && !this.attachments.length) || isSaving"
                                (click)="doneEditNote()">
                                {{ 'save' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            }
        </div>
        <div class="print-hidden">
            <div dropdown placement="bottom right" container="body">
                <button
                    class="btn btn-icon btn-transparent"
                    dropdownToggle
                    type="button"
                    aria-controls="dropdown-basic">
                    <sb-inline-svg
                        class="icon"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/More icon.svg'">
                    </sb-inline-svg>
                </button>
                <ul
                    id="dropdown-basic"
                    *dropdownMenu
                    class="dropdown-menu dropdown-menu-right"
                    role="menu"
                    aria-labelledby="button-basic">
                    <li role="menuitem">
                        <button class="dropdown-item" type="button" ngxClipboard [cbContent]="noteLink">
                            {{ 'Copy link' | translate }}
                        </button>
                    </li>
                    @if (note.isEditable && isEditableNote && !commonDataService.user.isReadOnly) {
                        <li role="menuitem">
                            <button class="dropdown-item" type="button" (click)="showEditView()">
                                {{ 'Edit' | translate }}
                            </button>
                        </li>
                    }
                    @if (note.isDeletable) {
                        <li role="menuitem">
                            <button class="dropdown-item" type="button" (click)="openDeleteModal()">
                                {{ 'Delete' | translate }}
                            </button>
                        </li>
                    }
                </ul>
            </div>
        </div>
    </div>
}

<app-mention-notification [noteId]="note.id" [usersWithoutAccess]="note.usersWithoutAccess"></app-mention-notification>
@if (!note.isCollapsed || parent.isForPrinting) {
    <div class="sub-note-block">
        @if (!note.areCommentsShown && note.subNotes.length > 1) {
            <button
                class="btn btn-notification btn-sm sub-note-button print-hidden"
                (click)="note.areCommentsShown = !note.areCommentsShown">
                <sb-inline-svg
                    class="icon icon-heart"
                    [url]="'/sb-tools/theme/images/icons/Thin Icon - Conversation.svg'"></sb-inline-svg>
                <span>{{
                    note | textForNotesExpander: note.subNotes.length : noteService.noteIdWithMentionedUser
                }}</span>
            </button>
        }

        @for (
            subNote of note.subNotes
                | lastSubReply: note : note.areCommentsShown || parent.isForPrinting : note.subNotes?.length : false;
            track subNote;
            let idx = $index
        ) {
            <app-note-item
                class="sub-note"
                [isSubNote]="true"
                [parentNote]="note"
                [note]="subNote"
                [index]="idx"
                (handleDelete)="handleDeleteSubNote($event)"></app-note-item>
        }
    </div>
}

@if (note.isSubNoteEditorShown && !isSubNote) {
    <div class="mt-2 mb-2 new-sub-note print-hidden">
        <app-new-note
            [ticketId]="parent.ticket.id"
            [newNote]="note.newSubNote"
            [isCancelAllowed]="true"
            [parentNoteId]="note.id"
            [noteId]="note.id"
            (noteAdd)="onSubNoteAdd($event, note)"
            (closeNoteEditor)="toggleSubNoteEditor(false)"></app-new-note>
    </div>
}
